/**
 * Enums de domínio. Espelham os enums do Prisma em packages/db — ao mexer aqui,
 * mexa lá (packages/db/src/espelho.test.ts falha se divergirem).
 * Vivem aqui, e não em @du/db, porque o cardápio e a gestão rodam no browser
 * e não podem importar Prisma.
 */
export const StatusPedido = {
    RECEBIDO: 'RECEBIDO',
    ACEITO: 'ACEITO',
    EM_PREPARO: 'EM_PREPARO',
    PRONTO: 'PRONTO',
    SAIU_PARA_ENTREGA: 'SAIU_PARA_ENTREGA',
    ENTREGUE: 'ENTREGUE',
    CANCELADO: 'CANCELADO',
};
export const TipoEntrega = { ENTREGA: 'ENTREGA', RETIRADA: 'RETIRADA', BALCAO: 'BALCAO' };
export const CanalPedido = { SITE: 'SITE', WHATSAPP: 'WHATSAPP', BALCAO: 'BALCAO', IA: 'IA' };
export const FormaPagamento = {
    DINHEIRO: 'DINHEIRO',
    CARTAO_ENTREGA: 'CARTAO_ENTREGA',
    PIX_MANUAL: 'PIX_MANUAL',
    PIX_ONLINE: 'PIX_ONLINE',
};
export const StatusPagamento = {
    PENDENTE: 'PENDENTE',
    PAGO: 'PAGO',
    ESTORNADO: 'ESTORNADO',
    FALHOU: 'FALHOU',
};
export const Papel = {
    ADMIN: 'ADMIN',
    GERENTE: 'GERENTE',
    ATENDENTE: 'ATENDENTE',
    COZINHA: 'COZINHA',
    ENTREGADOR: 'ENTREGADOR',
};
export const ViaComanda = { COZINHA: 'COZINHA', CAIXA: 'CAIXA', AMBAS: 'AMBAS' };
/**
 * WhatsApp. Espelham os enums do Prisma — o front e a API comparam por estes
 * valores em vez de por string solta, que é como um typo vira bug silencioso.
 */
export const ProvedorWhats = { WAHA: 'WAHA', META_CLOUD: 'META_CLOUD' };
export const StatusConversa = { BOT: 'BOT', HUMANO: 'HUMANO', ENCERRADA: 'ENCERRADA' };
export const DirecaoMsg = { ENTRADA: 'ENTRADA', SAIDA: 'SAIDA' };
/**
 * Tipos de evento do tempo real — FONTE ÚNICA.
 *
 * EventSource não tem listener curinga: o navegador só chama o handler de um
 * `event:` que foi registrado pelo nome. Enquanto esta lista estava duplicada
 * dentro do cliente SSE, acrescentar um tipo novo no servidor compilava,
 * publicava, chegava no navegador — e era descartado em silêncio, sem erro em
 * lugar nenhum. Aconteceu com `whatsapp.sessao`.
 *
 * Agora o servidor tipa por esta lista e o cliente registra por esta lista.
 * Um tipo novo entra aqui e os dois lados acompanham.
 */
export const TIPOS_EVENTO = [
    'pedido.criado',
    'pedido.status',
    'pedido.atualizado',
    'pedido.pagamento',
    'impressao.status',
    'impressora.status',
    'catalogo.atualizado',
    'loja.atualizada',
    'whatsapp.sessao',
    'whatsapp.mensagem',
];
//# sourceMappingURL=dominio.js.map